const HTML_MAIL_RELANCE_DEFAUT =
  '<p>{Civilite_payeur} {Nom_payeur},</p>' +
  '<p><br></p>' +
  "<p>Veuillez trouver ci-joint une demande de paiement en date du {Date_du_jour}, d'un montant de <strong>{Montant_total}</strong> €, délivrée par la {Nom_regie}.</p>" +
  '<p><br></p>' +
  "<p>Vous y trouverez le détail des factures concernées, ainsi que les délais et modalités d'acquittement.</p>" +
  '<p><br></p>' +
  '<p>Pour toute question, adressez-vous à :</p>' +
  '<p><br></p>' +
  '<p>{Nom_regie}</p>' +
  '<p>{Adresse_regie}</p>' +
  '<p>{Telephone_regie}</p>' +
  '<p>{Courriel_regie}</p>' +
  '<p><br></p>' +
  "<p>Horaires d'ouverture :</p>" +
  '<p>{Horaires_ouverture}</p>' +
  '<p><br></p>' +
  '<p><br></p>' +
  '<p>Cordialement,</p>' +
  '<p>{Nom_regisseur}, {Type_regisseur}</p>';

export default HTML_MAIL_RELANCE_DEFAUT;
